import { render, staticRenderFns } from "./BuildButtonBlock.vue?vue&type=template&id=6b512e6d&scoped=true&"
import script from "./BuildButtonBlock.vue?vue&type=script&lang=js&"
export * from "./BuildButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./BuildButtonBlock.vue?vue&type=style&index=0&id=6b512e6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b512e6d",
  null
  
)

export default component.exports